import reducer from './reducer.js';
import view from './view.js';

export {reducer, view};



// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/index.js